module.exports = "<div [innerHTML]=\"data\"></div>"